<template>
    <div class="app">
        <AppHeader />
        <div class="app-body">
            <Sidebar :navItems="nav" />
            <main class="main">
                <breadcrumb :list="list" />
                <div class="container-fluid pl-0">
                    <router-view></router-view>
                </div>
            </main>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import
{
    mapGetters,
    mapActions
}
from 'vuex'
import
{
    Header as AppHeader,
    Sidebar,
    Footer as AppFooter,
    Breadcrumb
}
from '../components/admin/'

export default
{
    name: 'full',
    components:
    {
        AppHeader,
        Sidebar,
        AppFooter,
        Breadcrumb
    },
    data()
    {
        var me = this;
        return {
            nav: []
        }
    },
    created()
    {
        if (this.langInitialized)
        {
            this.initMenu();
        }
    },
    methods:
    {
        initMenu()
        {
            var me = this;

            this.nav = [
            {
                name: me.$i18n.t('DASHBOARD'),
                url: '/dashboard',
                visible: (me.globals.acl.Dashboard && me.globals.acl.Dashboard.instantiate) ? true : false,
                icon: 'home'
            },
            {
                name: me.$i18n.t('JOB'),
                url: '/job',
                visible: (me.globals.acl.Job && me.globals.acl.Job.instantiate) ? true : false,
                icon: 'user-tie'
            },
            {
                name: me.$i18n.t('JOBRECURRING'),
                url: '/job_recurring',
                visible: (me.globals.acl.JobRecurring && me.globals.acl.JobRecurring.insertAction) ? true : false,
                icon: 'sync'
            },
            {
                name: me.$i18n.t('FLOW'),
                url: '/flow',
                visible: (me.globals.acl.Flow && me.globals.acl.FlowHistory.deleteAction && me.globals.canSeeCompanyDetails !== 1) ? true : false,
                icon: 'list'
            },
            {
                name: me.$i18n.t('FLOWSEC'),
                url: '/flowsec',
                visible: (me.globals.acl.Flow && me.globals.acl.FlowHistory.deleteAction && me.globals.canSeeCompanyDetails !== 1) ? true : false,
                icon: 'list'
            },
            {
                name: me.$i18n.t('BUILDINGDETAIL'),
                url: '/building_detail',
                visible: (me.globals.acl.BuildingDetail && me.globals.acl.BuildingDetail.insertAction) ? true : false,
                icon: 'address-card'
            },
            {
                name: me.$i18n.t('OBJECTDETAILS'),
                url: '/object_details',
                visible: (me.globals.acl.ObjectDetails && me.globals.acl.ObjectDetails.insertAction),
                icon: 'address-card'
            },
            /*
            {
                name: me.$i18n.t('CHECKLIST'),
                url: '/check_list',
                visible: (me.globals.acl.CheckList && me.globals.acl.CheckList.insertAction),
                icon: 'list-alt'
            }, */
            {
                name: me.$i18n.t('USERSUBCOMPANIES'),
                url: '/system/usersubcompanies',
                visible: (me.globals.acl.UserSubCompanies && me.globals.acl.UserSubCompanies.insertAction) ? true : false,
                icon: 'building'
            },
            {
                name: me.$i18n.t('SYSTEM'),
                icon: 'cog',
                visible: (me.globals.acl.Users && me.globals.acl.Users.insertAction) ? true : false,
                children: [
                    {
                        name: me.$i18n.t('ACLGROUPS'),
                        url: '/system/aclgroups',
                        visible: (me.globals.acl.AclGroups && me.globals.acl.AclGroups.insertAction) ? true : false,
                        icon: 'coffee'
                    },
                    {
                        name: me.$i18n.t('ACL'),
                        url: '/system/acl',
                        visible: (me.globals.acl.AclPrivilages && me.globals.acl.AclPrivilages.insertRow && me.globals.acl.AclPrivilages.insertRow.instantiate) ? true : false,
                        icon: 'lock'
                    },
                    {
                        name: me.$i18n.t('TRANSLATOR'),
                        url: '/system/translator',
                        visible: (me.globals.acl.Translator && me.globals.acl.Translator.insertAction) ? true : false,
                        icon: 'flag'
                    },
                    {
                        name: me.$i18n.t('LANGUAGES'),
                        url: '/system/languages',
                        visible: (me.globals.acl.TransLang && me.globals.acl.TransLang.insertAction) ? true : false,
                        icon: 'globe'
                    },
                    {
                        name: me.$i18n.t('SITEPROPS'),
                        url: '/system/siteprops',
                        visible: (me.globals.acl.SiteProps && me.globals.acl.SiteProps.insertAction) ? true : false,
                        icon: 'wrench'
                    },
                    {
                        name: me.$i18n.t('EMAILTEMPLATES'),
                        url: '/system/emailtemplates',
                        visible: false,
                        icon: 'envelope'
                    },
                    {
                        name: me.$i18n.t('USERCOMPANIES'),
                        url: '/system/usercompanies',
                        visible: (me.globals.acl.UserCompanies && me.globals.acl.UserCompanies.insertAction) ? true : false,
                        icon: 'building'
                    },
                    {
                        name: me.$i18n.t('USERS'),
                        url: '/system/users',
                        visible: (me.globals.acl.Users && me.globals.acl.Users.insertAction) ? true : false,
                        icon: 'user'
                    },
                    {
                        name: me.$i18n.t('GENERATOR'),
                        url: '/system/generator',
                        visible: false,
                        icon: 'rocket'
                    } //GENERATORINSERT
                ]
            }]
        }
    },
    watch:
    {
        translation()
        {
            this.initMenu();
        },
        langInitialized()
        {
            this.initMenu();
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'langInitialized',
            'translation'
        ]),
        name()
        {
            return this.$route.name
        },
        list()
        {
            const routeMatched = this.$route.matched;
            const route = this.$route;

            if (route != null && route.name != null)
            {
                if (route.matched != null && route.matched.length > 0)
                {
                    const newRouteMatched = [];
                    if (route.name === 'FLOW')
                    {
                        delete (route.matched[0].diffrentName);
                        newRouteMatched.push(route.matched[0]);
                        newRouteMatched.push(route.matched[1]);
                        return newRouteMatched;
                    }

                    if (route.name === 'FLOWSEC')
                    {
                        delete (route.matched[0].diffrentName);
                        newRouteMatched.push(route.matched[0]);
                        newRouteMatched.push(route.matched[1]);
                        return newRouteMatched;
                    }

                    if (route.name === 'STEP')
                    {
                        if (route.matched[0].diffrentName == null)
                        {
                            route.matched[0].diffrentName = route.query.flowName;
                        }                        
                        newRouteMatched.push(route.matched[0]);
                        newRouteMatched.push(route.matched[3]);
                        return newRouteMatched;
                    }

                    if (route.name === 'STEPBUTTONS' || route.name === 'QUESTIONS')
                    {
                        if (route.matched[0].diffrentName == null)
                        {
                            route.matched[0].diffrentName = route.query.flowName;
                        }
                        newRouteMatched.push(route.matched[0]);
                        route.matched[2].diffrentName = route.query.stepName;
                        newRouteMatched.push(route.matched[2]);
                        newRouteMatched.push(route.matched[3]);
                        return newRouteMatched;
                    }
                }
            }
            return routeMatched;
        }
    }
}
</script>

<style scoped>
.app {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.app-body {
    flex: 1;
    overflow: hidden;
    display: flex;
}

.main {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}
</style>
